import * as React from "react";
import { AppShape, PropertyTypes } from "@eave/shared/types/api";
import { formatCurrency } from "@eave/shared/utils/currency";
import { getPropertyTypeUnits } from "web_modules/shared/propertyTypeUnits";
import { verticalHeaderTRUSTable } from "./shared";

const styles = require("./styles.module.scss");

interface Props {
  app: AppShape;
}

const convertPropertyType = propertyType => {
  const detatchedType = [
    PropertyTypes.SFR,
    PropertyTypes.PUD,
    PropertyTypes.Duplex,
    PropertyTypes.Triplex,
    PropertyTypes.Quadplex,
  ];
  const attachedTypes = [
    PropertyTypes.SFRATT,
    PropertyTypes.PUDATT,
    PropertyTypes.DuplexATT,
    PropertyTypes.TriplexATT,
    PropertyTypes.QuadplexATT,
  ];
  const condoTypes = [
    PropertyTypes.SiteCondo,
    PropertyTypes.LowRiseCondo,
    PropertyTypes.MidRiseCondo,
    PropertyTypes.HighRiseCondo,
  ];

  if (detatchedType.includes(propertyType)) {
    return "Detached";
  }

  if (attachedTypes.includes(propertyType)) {
    return "Attached Non-Condo";
  }

  if (condoTypes.includes(propertyType)) {
    return "Condo";
  }

  return "Unknown Property Type";
};

const PropertyInfo: React.FC<Props> = ({ app }: Props) => {
  const propertyType: any = app.operator_subject_property_type || app.property_type;
  const table1 = [
    { label: "Occupancy Type", value: app.property_usage },
    { label: "Property Type", value: convertPropertyType(propertyType) },
    { label: "Number of Units", value: getPropertyTypeUnits(propertyType) },
    {
      label: "Appraised Value",
      value: app.appraisal ? formatCurrency(app.appraisal.appraised_value, 2, 2) : "N/A",
    },
    {
      label: "Purchase Price",
      value: formatCurrency(app.computed_properties.purchase_price, 2, 2),
    },
    {
      label: "Subordinate Financing Amount",
      value: formatCurrency(0, 2, 2),
    },
  ];
  const table2 = [
    {
      label: "Address",
      value: `${app.computed_properties.purchased_property_address.line1}${
        app.computed_properties.purchased_property_address.line2
          ? `, ${app.computed_properties.purchased_property_address.line2}`
          : ""
      }`,
    },
    { label: "City", value: app.computed_properties.purchased_property_address.city },
    { label: "State", value: app.computed_properties.purchased_property_address.state },
    {
      label: "Zip",
      value: app.computed_properties.purchased_property_address.postal_code.split("-")[0],
    },
    {
      label: "County",
      value: app.computed_properties.purchased_property_county || app.property_county,
    },
  ];

  return (
    <>
      <h2>Property Information and Details of Transaction</h2>
      <div className={styles.table}>
        {verticalHeaderTRUSTable(table1)}
        {verticalHeaderTRUSTable(table2)}
      </div>
    </>
  );
};

export default PropertyInfo;
